import CustomRequestForm from '../../components/CustomRequestForm/CustomRequestForm';

const LandingPageRequest = () => (
  <>
    <title>Landing Page anfragen – Nexite IT</title>
    <meta name="robots" content="noindex" />
    <CustomRequestForm
    planTitle="Premium Landing Page"
    features={[
      'Modernes & Konversionsoptimiertes Design',
      'Mobile-optimierte Umsetzung',
      'Integration mit Analytics-Tools',
      'A/B Testing Vorbereitung',
      'Lead-Generierung Formulare',
      'Social Media Integration',
      '2 Monate Wartung inklusive',
      '3 Jahre Gültigkeit des Angebots',
      'Hosting & Domain (1 Jahr)',
      'Performance-Optimierung'
    ]}
    originalPrice={3900}
    discountPrice={2200}
    serviceId="service_02f1b5n"
    templateId="template_a1924op"
    publicKey="Et4UfxopuEn0IbQm8"
    returnLink="/services"
    successMessage="Vielen Dank für Ihr Interesse an unserer Landing Page! Unser Team wird sich innerhalb von 24 Stunden mit einem individuellen Angebot bei Ihnen melden."
    formFields={[
      {
        name: 'company',
        label: 'Firmenname',
        type: 'text',
        required: true,
        placeholder: 'Ihre Firma GmbH'
      },
      {
        name: 'name',
        label: 'Ihr Name',
        type: 'text',
        required: true,
        placeholder: 'Max Mustermann'
      },
      {
        name: 'email',
        label: 'E-Mail-Adresse',
        type: 'email',
        required: true,
        placeholder: 'max@mustermann.de'
      },
      {
        name: 'phone',
        label: 'Telefonnummer',
        type: 'tel',
        placeholder: '+49 170 1234567'
      },
      {
        name: 'message',
        label: 'Besondere Anforderungen',
        type: 'textarea',
        placeholder: 'Gibt es spezielle Funktionen oder Besonderheiten, die Sie benötigen?'
      }
    ]}
    buttonText="Angebot anfordern"
    />
  </>
);

export default LandingPageRequest;